import { useMutation, useQueryClient } from '@tanstack/react-query';
import assignRoute from './assignRoute';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { NOTIFICATION_TYPES } from '../../../../config/consts/commons';
import { setMessage } from '../../../toasts/toastSlice';
import { handleAxiosErrorMessage } from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { ROUTE_TYPES } from '../../../../config/consts/routes';
import { setRouteType } from '../../routeSlice';

function useAssignRoute({ routeType }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { t } = useTranslation(['system']);
  const { username: id_clouder } = useSelector((store) => store.auth);

  return useMutation({
    mutationKey: ['assignRoute'],
    mutationFn: (data) => assignRoute({ ...data, id_clouder }),
    onSuccess: (_, variables) => {
      const { id_route } = variables;
      dispatch(
        setMessage({
          body: t('SAVE_ASSIGN_ROUTE', { ns: 'system', route: id_route }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );

      dispatch(setRouteType(routeType));

      if (routeType !== ROUTE_TYPES.EXPRESS) {
        navigate('/orders/dashboard');
      }
    },
    onError: (error) => {
      const errorMessage = handleAxiosErrorMessage(error);
      dispatch(
        setMessage({
          body: t(errorMessage, { ns: 'system' }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['getEnabledRoutes'] });
      queryClient.invalidateQueries({ queryKey: ['getActiveRoute'] });
    },
  });
}

export default useAssignRoute;
